<template>
    <v-select
            v-model="item"
            dir="rtl"
            :multiple="multiple"
            label="Title"
            :reduce="x => x.Id"
            :options="items"
            :loading="loading"
            :clearable="clearable"
            :selectable="x => unselectable.includes(x.Id) === false || x === val"
            @open="onOpen"
            @option:selected="$emit('selectedItem',$event)"
    >
    <span
            slot="no-options"
            @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
        <template #spinner>
            <div class="demo-inline-spacing">
                <b-spinner
                        v-if="loading"
                        class="m-0"
                        small
                        variant="secondary"
                />
            </div>
        </template>
    </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
    name: 'Color',
    components: {
        vSelect,
    },
    props: {
        value: {
            type: [String, Number, Array],
            default: null,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        unselectable: {
            type: Array,
            default: () => [],
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            val: this.value,
            loading: false,
        }
    },
    watch: {
        value(v) {
            this.val = v
        },
    },
    computed: {
        ...mapState('zirehState', { items: state => state.colorSelect }),
        ...mapState('zirehState', { flag: state => state.colorSelectFlag }),
        item: {
            get() {
                if (this.value && (this.value.length || this.multiple === false)) {
                    this.get()
                }
                return this.val
            },
            set(newValue) {
                this.$emit('input', newValue)
                this.val = newValue
            },
        },
    },
    methods: {
        get() {
            if (this.flag === false && this.items.length === 0) {
                this.$store.commit('zirehState/setColorSelectFlag', true)
                this.loading = true
                this.$http.post(
                    this.$api.color.getall, {},
                )
                    .then(res => {
                        this.$store.commit('zirehState/setColorSelect', res.data)
                        this.loading = false
                    })
            }
        },
        onOpen() {
            this.get()
        },
    },
}
</script>
